module.exports = __webpack_public_path__ + "static/media/openlite-wordpress.77f231ae.svg";